import splitIntoLines from "../../../utils/splitWords";

function OnePerson({ imgSrc, name, position, LinkedInIcon, linkedin }) {
   if (position.length > 60) {
      let res = splitIntoLines(position, 30)
      position = <>{res[0]}<br />{res[1]}<br />{res[2]}</>
   } else if (position.length > 40) {
      let middle = Math.floor(position.length / 2);
      let before = position.lastIndexOf(' ', middle);
      let after = position.indexOf(' ', middle + 1);

      if (middle - before < after - middle) {
         middle = before;
      } else {
         middle = after;
      }

      let s1 = position.substr(0, middle);
      let s2 = position.substr(middle + 1);
      position = <>{s1}<br />{s2}</>
   }

   return (
      <div style={{ margin: "10px", flexGrow: 1 }}>
         {imgSrc !== "" && (
            <div className="SingleOnePerson" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
               <img
                  className="img-fluid"
                  src={imgSrc}
                  alt="person"
                  style={{
                     minHeight: "150px",
                     minWidth: "150px",
                     maxWidth: "150px",
                     maxHeight: "150px",
                     borderRadius: "50%",
                     boxShadow: "0 0 5px black",
                  }}
               />
               <div className="m-0" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <p className="m-0 p-0 sponsorName">{name}</p>
                  <p className="m-0 p-0" style={{ color: "grey", fontSize: "15px" }}>
                     {position}{" "}
                     <a rel='noreferrer' href={linkedin} target="_blank" style={{ textDecoration: "none" }}>
                        <span>
                           <LinkedInIcon style={{ color: "#0072b1" }} />
                        </span>
                     </a>
                  </p>
               </div>
            </div>
         )}
      </div>
   );
}

export default OnePerson;
